import { FC, useEffect, useState } from 'react';
import { ISurveysEntry } from '../../shared/interfaces/ISurveysEntry';
import { Box, Divider, LinearProgress, useTheme } from '@mui/material';
import GaugeComponent from 'react-gauge-component';
import SurveyService from '../../services/SurveyService';

interface Props {
  survey: ISurveysEntry;
}

interface NpsSurveyScores {
  netPromoterScore: number;
}

const SurveyNpsGaugeChart: FC<Props> = ({ survey }) => {
  const theme = useTheme();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<NpsSurveyScores | null>(null);

  useEffect(() => {
    const controller = new AbortController();

    const getScore = async () => {
      try {
        const response = await SurveyService.getNpsSurveyScore(
          survey.id,
          setLoading,
          controller.signal
        );
        if (response) {
          setData(response);
          setLoading(false);
        } else {
          return;
        }
      } catch (error) {
        console.error('Error fetching score:', error);
      }
    };

    getScore();

    return () => {
      controller.abort();
    };
  }, []);

  return (
    <Box>
      {loading ? (
        <Box>
          <LinearProgress sx={{ mt: theme.spacing(1), mb: theme.spacing(2) }} />
        </Box>
      ) : (
        <>
          <GaugeComponent
            type="radial"
            labels={{
              valueLabel: {
                matchColorWithArc: true,
                formatTextValue: (v: string | number) => {
                  return v + '';
                },
                style: {
                  fontSize: '35px',
                  textShadow: 'none',
                },
              },
              tickLabels: {
                type: 'inner',
                ticks: [
                  { value: -100 },
                  { value: -66 },
                  { value: -33 },
                  { value: 0 },
                  { value: 33 },
                  { value: 66 },
                  { value: 100 },
                ],
              },
            }}
            arc={{
              colorArray: ['#ea676d', '#ee7c57', '#f39f32', '#f6b31a', '#9db136', '#4eaf50'],
              padding: 0.02,
              subArcs: [
                { limit: -66 },
                { limit: -33 },
                { limit: 0 },
                { limit: 33 },
                { limit: 66 },
                {},
              ],
            }}
            pointer={{
              color: '#000',
              length: 0.8,
              width: 15,
              elastic: true,
            }}
            minValue={-100}
            maxValue={100}
            value={Math.round(data?.netPromoterScore || 0)}
          />
        </>
      )}
    </Box>
  );
};

export default SurveyNpsGaugeChart;
